// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/cob-shipping-payment-selection/" + "cob-shipping-payment-selection.cob-shipping-payment-selection-plugin.plugin" + "." + "b3d995" + ".js";
};